import { SchemaItem } from '../interface'

export const hasTooltip = (schema: SchemaItem) => {
  return !!schema['x-decorator-props']?.tooltip
}
